  <template>
  <div style="overflow-y: hidden">
    <div class="top">
      <div class="search_icon">
        <span style="margin-left: 10px">
          <img src="../../../../assets/u3220.png" class="icon_img" />
          筛选查询
        </span>
      </div>
      <div class="query_div">
        <a-row>
          <a-col :span="5">
            <label>模版名称：</label>
            <a-input
              placeholder="请输入"
              class="query_input"
              v-model="queryName"
            />
          </a-col>
          <a-col :span="5">
            <label>模版类型：</label>
            <a-select defaultValue="0" class="query_input" v-model="queryType">
              <a-select-option value="0">全部</a-select-option>
              <a-select-option value="2">收稿</a-select-option>
              <a-select-option value="5">审稿</a-select-option>
              <a-select-option value="6">催审</a-select-option>
              <a-select-option value="8">缴费</a-select-option>
              <a-select-option value="9">催缴</a-select-option>
              <a-select-option value="3">退改</a-select-option>
              <a-select-option value="4">退稿</a-select-option>
              <a-select-option value="7">采用</a-select-option>
            </a-select>
          </a-col>
          <a-button type="primary" class="query_btn" @click="query"
            >查询</a-button
          >
          <a-button type="primary" @click="addEmail()" style="margin-left: 10px"
            >新增</a-button
          >
        </a-row>
      </div>
    </div>

    <div class="middle">
      <div style="float: left; margin-left: 10px">
        <img src="../../../../assets/u3227.png" class="icon_img" />
        <span>&nbsp;数据列表</span>
      </div>
      <div class="sortType" style="float: right">
        排序方式：
        <a-select
          size="small"
          defaultValue="1"
          style="width: 120px"
          @change="sortChange"
          v-model="sort"
        >
          <a-select-option value="1">时间降序</a-select-option>
          <a-select-option value="2">时间升序</a-select-option>
        </a-select>
      </div>
    </div>

    <div class="bottom" id="bottom">
      <div class="table_box">
        <a-table
          :pagination="false"
          :rowSelection="rowSelection"
          :columns="columns"
          :dataSource="data"
          :rowKey="(record) => record.templateCode"
          size="small"
          :scroll="{ y: data.length < 8 ? false : table_height }"
          bordered
        >
          <span slot="operate" slot-scope="text, record">
            <a href="javascript:void(0);" @click="() => lookEmail(record)"
              >查看</a
            >
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => editEmail(record)"
              >编辑</a
            >
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => changeStatus(record, 1)"
              >启用</a
            >
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => changeStatus(record, 0)"
              >禁用</a
            >
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => deleteMethod(record)"
              >删除</a
            >
          </span>
          <span slot="status" slot-scope="text, record">
            <label v-if="record.status == 1">
              <img class="status_img" src="../../../../assets/open.png" />已启用
            </label>
            <label v-if="record.status == 0">
              <img
                class="status_img"
                src="../../../../assets/close.png"
              />已禁用
            </label>
          </span>
          <span slot="templateType" slot-scope="text, record">
            <label v-if="record.templateType == 2">收稿</label>
            <label v-if="record.templateType == 3">退改</label>
            <label v-if="record.templateType == 4">退稿</label>
            <label v-if="record.templateType == 5">审稿</label>
            <label v-if="record.templateType == 6">催审</label>
            <label v-if="record.templateType == 7">采用</label>
            <label v-if="record.templateType == 8">缴费</label>
            <label v-if="record.templateType == 9">催缴</label>
            <label v-if="record.templateType == 10">发送回执</label>
          </span>
          <span slot="lang" slot-scope="text, record">
            <label v-if="record.lang == 'CN'">中文</label>
            <label v-if="record.lang == 'EN'">英文</label>
          </span>
        </a-table>
      </div>

      <div id="components-pagination-demo-mini">
        <a-pagination
          :total="total"
          :showTotal="(total) => `共 ${total} 条`"
          showSizeChanger
          showQuickJumper
          :pageSizeOptions="pageSizeOptions"
          :defaultPageSize="limit"
          @showSizeChange="onShowSizeChange"
          @change="pageChange"
        />
      </div>
      <a-select
        defaultValue="0"
        class="batch_operation"
        @change="operateChange"
        v-model="operateCode"
      >
        <a-select-option value="0">批量操作</a-select-option>
        <a-select-option value="1">批量导出</a-select-option>
        <a-select-option value="2">批量禁用</a-select-option>
        <a-select-option value="3">批量启用</a-select-option>
      </a-select>
    </div>
    <a-modal
      title="提示"
      v-model="delVisible"
      @ok="deleteOk"
      :centered="true"
      width="300px"
      :maskClosable="false"
    >
      <p>确认删除吗？</p>
    </a-modal>
  </div>
</template>
<script>
import moment from "moment";
const columns = [
  {
    title: "模板类型",
    dataIndex: "templateType",
    width: 100,
    scopedSlots: { customRender: "templateType" },
  },
  {
    title: "模板名称",
    dataIndex: "name",
  },
  {
    title: "语言类型",
    width: 120,
    dataIndex: "lang",
    scopedSlots: { customRender: "lang" },
  },
  {
    title: "状态",
    width: 100,
    dataIndex: "status",
    scopedSlots: { customRender: "status" },
  },
  {
    title: "创建者",
    width: 120,
    dataIndex: "createrName",
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
  },
  {
    title: "操作",
    width: 280,
    key: "operate",
    scopedSlots: { customRender: "operate" },
  },
];
const data = [];
import qs from "qs";

export default {
  name: "Email",
  data() {
    return {
      value: 1,
      columns,
      data,
      visible: false,
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      selectedRowKeys: [],
      queryName: "",
      queryType: "0",
      delVisible: false,
      delCode: "",
      operateCode: "0",
      sort: "1",
      sortField: "create_time",
      sortType: "desc",
      page: 1,
      limit: 20,
      total: 0,
      table_height: 0,
      serviceAddress: this.$config.serviceAddress,
    };
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        columnWidth: 35,
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,
        onSelection: this.onSelection,
      };
    },
  },
  created() {
    this.query();
  },
  mounted() {
    //设置bottom高度
    var height = document.body.clientHeight;
    var bottom_height = height - 230;
    var bottom = document.getElementById("bottom");
    bottom.style.height = bottom_height + "px";
    this.table_height = bottom_height - 100;
  },
  methods: {
    moment,
    onShowSizeChange(current, pageSize) {
      this.page = current;
      this.limit = pageSize;
      this.query();
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    pageChange(pageNumber) {
      this.page = pageNumber;
      this.query();
    },
    deleteMethod(record) {
      this.delVisible = true;
      this.delCode = record.templateCode;
    },
    deleteOk() {
      this.axios
        .post("/emailTemplate/deleteEmailTemplate", {
          templateCode: this.delCode,
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.utils.messageInfo(this, "success", "删除成功");
            this.delVisible = false;
            this.query();
          } else {
            this.utils.messageInfo(this, "error", "删除失败！");
          }
        });
    },
    sortChange(value) {
      if (value == 1) {
        this.sortType = "desc";
      } else if (value == 2) {
        this.sortType = "";
      }
      this.query();
    },
    operateChange() {
      var itemLegth = this.selectedRowKeys.length;
      if (itemLegth == 0) {
        this.utils.messageInfo(this, "error", "最少选择一条数据！");
        return;
      }
      if (this.operateCode == 1) {
        if (this.serviceAddress == "") {
          this.utils.messageInfo(
            this,
            "error",
            "获取后台ip地址失败，无法导出！"
          );
          return;
        }
        var selectedRowKeys = this.selectedRowKeys;
        window.open(
          this.serviceAddress +
            "/emailTemplate/exportData?codeArr=" +
            selectedRowKeys +
            ""
        );
      } else if (this.operateCode == 2) {
        this.batchChangeStatus(0);
      } else if (this.operateCode == 3) {
        this.batchChangeStatus(1);
      }
    },
    batchChangeStatus(status) {
      this.axios
        .post("/emailTemplate/changeStatus", {
          status: status,
          codes: JSON.stringify(this.selectedRowKeys),
        })
        .then((res) => {
          if (res.data.code == "OK") {
            if (status == "0") {
              this.utils.messageInfo(this, "success", "禁用成功！");
            } else {
              this.utils.messageInfo(this, "success", "启用成功！");
            }
            this.query();
          } else {
            this.utils.messageInfo(this, "error", "操作失败！");
          }
        });
    },
    query() {
      this.axios
        .get("/emailTemplate/queryEmailTemplate", {
          params: {
            name: this.queryName,
            templateType: this.queryType,
            sortField: this.sortField,
            sortType: this.sortType,
            page: this.page,
            limit: this.limit,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "0") {
            this.total = res.data.count;
            this.data = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询栏目列表失败！");
          }
        });
    },
    changeStatus(obj, status) {
      var codes = [];
      codes.push(obj.templateCode);
      this.axios
        .post("/emailTemplate/changeStatus", {
          codes: JSON.stringify(codes),
          status: status,
        })
        .then((res) => {
          if (res.data.code == "OK") {
            if (status == "0") {
              this.utils.messageInfo(this, "success", "禁用成功！");
            } else {
              this.utils.messageInfo(this, "success", "启用成功！");
            }
            this.query();
          } else {
            this.utils.messageInfo(this, "error", "编辑失败！");
          }
        });
    },
    addEmail() {
      this.$router.push({
        path: "/addEmail",
        query: { methed: "add", record: {} },
      });
    },
    lookEmail(record) {
      this.$router.push({
        path: "/checkEmail",
        query: { methed: "look", record: JSON.stringify(record) },
      });
    },
    editEmail(record) {
      this.$router.push({
        path: "/addEmail",
        query: { methed: "edit", record: JSON.stringify(record) },
      });
    },
  },
};
</script>
<style>
@import "../../../../assets/css/PageCss.css";
</style>
<style scoped>
.status_img {
  width: 18px;
  margin-right: 6px;
  margin-bottom: 3px;
}
</style>



